import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminQA = lazy(() => import("@/pages/admin/AdminQA"));

export const Route = createFileRoute("/admin/qa")({
  component: AdminQA,
});
